<template>
  <div class="union">
    <v-ribbon v-if="ribbonText" position="right">{{ ribbonText }}</v-ribbon>
    <div class="union__content-wrapper">
      <slot name="text"></slot>
      <div class="union__content-wrapper__input-wrapper">
        <div
          v-if="ctaText && !current"
          class="union__content-wrapper__ctaText bg-primary text-light p-2"
        >
          <v-text>{{ ctaText }}</v-text>
          <div class="bg-primary union__content-wrapper__ctaText__arrow"></div>
        </div>
        <slot name="content" :show="show"></slot>
      </div>
    </div>
    <div v-if="current === 'inputModal'" class="union__modal">
      <header class="union__modal__header d-md-none">
        <v-icon name="logo" class="union__modal__header__logo"></v-icon>
        <div @click="clearSelected()">
          <v-icon name="close" class="union__modal__header__close"></v-icon>
        </div>
      </header>
      <slot name="input-modal"></slot>
      <portal to="unionClearButton">
        <v-button inverted @click="clearSelected()">Fortryd</v-button>
      </portal>
    </div>
    <div v-if="current === 'confirmModal'" class="union__modal">
      <header class="union__modal__header d-md-none">
        <v-icon name="logo" class="union__modal__header__logo"></v-icon>
        <div @click="clearSelected()">
          <v-icon name="close" class="union__modal__header__close"></v-icon>
        </div>
      </header>
      <slot name="confirm-modal"></slot>
    </div>
    <div
      v-if="current && current != '0'"
      class="union__outside-clicker"
      @click="clearSelected()"
    ></div>
    <picture class="union__picture">
      <img :src="imgSrc" :alt="alt" />
    </picture>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: null,
      submitted: false
    };
  },
  props: {
    imgSrc: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: ""
    },
    ribbonText: {
      type: String,
      default: null
    },
    ctaText: {
      type: String,
      default: null
    },
    height: {
      type: [Number, String],
      default: "400px"
    }
  },
  methods: {
    show(type) {
      if (type === this.current) {
        this.current = "0";
      }
      this.current = type;
    },
    clearSelected() {
      this.current = "0";
      this.chosenOption = null;
      this.$emit("clear");
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../sass/component.scss";
@import "./_v-fagforening-for-mig.scss";
</style>
